export const BangladeshFlag = ({ className = "w-6 h-4" }) => (
  <svg
    viewBox="0 0 60 36"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Bangladesh flag"
  >
    <rect width="60" height="36" fill="#006A4E" />
    <circle cx="27" cy="18" r="10.8" fill="#F42A41" />
  </svg>
);

export const SwedenFlag = ({ className = "w-6 h-4" }) => (
  <svg
    viewBox="0 0 16 10"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Sweden flag"
  >
    <rect width="16" height="10" fill="#006AA7" />
    <rect x="5" width="2" height="10" fill="#FECC00" />
    <rect y="4" width="16" height="2" fill="#FECC00" />
  </svg>
);
